import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IEvl0108MState, IInquiryCndsState, IEvlCycleState, IYearOptionState, IAuthorizedUserState, IAllEmployeeState } from '../../models/evl/evl0108m_model';

const initialState: IEvl0108MState = {
  evlCycle       : [],
  inquiryCnds    : {},
  availableYears : [],
  authorizedUsers: [],
  allEmployees   : []
};

const evl0108mSlice = createSlice({
  name: 'evl0108m',
  initialState,
  reducers: {
    resetState: () => initialState,

    setEvlCycle(
      state,
      action: PayloadAction<IEvlCycleState[]>
    ) {
      state.evlCycle = action.payload;
    },

    setInquiryCnds(
      state,
      action: PayloadAction<IInquiryCndsState>
    ) {
      state.inquiryCnds = {
        ...state.inquiryCnds,
        ...action.payload
      };
    },

    setAvailableYears(
      state,
      action: PayloadAction<IYearOptionState[]>
    ) {
      state.availableYears = action.payload;
    },

    // 권한 보유자 목록 설정
    setAuthorizedUsers(
      state,
      action: PayloadAction<IAuthorizedUserState[]>
    ) {
      state.authorizedUsers = action.payload;
    },

    // 권한 보유자 추가
    addAuthorizedUser(
      state,
      action: PayloadAction<IAuthorizedUserState>
    ) {
      // 중복 체크
      const exists = state.authorizedUsers.some(user => user.userId === action.payload.userId);
      if (!exists) {
        state.authorizedUsers.push(action.payload);
      }
    },

    // 권한 보유자 삭제
    removeAuthorizedUser(
      state,
      action: PayloadAction<string> // userId
    ) {
      state.authorizedUsers = state.authorizedUsers.filter(
        user => user.userId !== action.payload
      );
    },

    // 전체 직원 목록 설정
    setAllEmployees(
      state,
      action: PayloadAction<IAllEmployeeState[]>
    ) {
      state.allEmployees = action.payload;
    },
  }
});

export default evl0108mSlice.reducer;
export const Evl0108mAction  = evl0108mSlice.actions;
export const Evl0108mReducer = evl0108mSlice.reducer;